export const DisplayType = {
    GRAPH: 'GRAPH',
    DATA_IN_GRAPH: 'DATA_IN_GRAPH',
    DATA_TABLE: 'DATA_TABLE',
};

export const DecimalType = {
    INTEGER: 'INTEGER',
    ONE_DECIMAL: 'ONE_DECIMAL',
    TWO_DECIMALS: 'TWO_DECIMAL',
};
